export const LOGO_URL = "/logo.png";

export const BRAND = {
  name: "Star Jewels",
  tagline: "Every piece, a little starlight.",
  instagram: "officialstarjewels",
  email: "officialstarjewels@gmail.com",
};

export const CATEGORIES = [
  { key: "earrings",  label: "Earrings" },
  { key: "necklaces", label: "Necklaces" },
  { key: "bracelets", label: "Bracelets" },
  { key: "rings",     label: "Rings" },
];

export const CATEGORY_IMAGES = {
  earrings:  "https://images.pexels.com/photos/32989030/pexels-photo-32989030.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  necklaces: "https://images.pexels.com/photos/28976815/pexels-photo-28976815.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  bracelets: "https://images.pexels.com/photos/14509641/pexels-photo-14509641.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  rings:     "https://images.pexels.com/photos/2849742/pexels-photo-2849742.jpeg",
};

export const HERO_IMAGE = "https://images.pexels.com/photos/36324985/pexels-photo-36324985.jpeg";
